/* eslint-disable indent */
// src/components/AchievementDashboard/index.tsx

"use client";

import React, { useEffect, useState } from "react";
import TaskCard from "@/components/atoms/TaskCard";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { fetchAllTasks } from "@/lib/actions";
import { TaskDTO } from "@/types";
import { colourScheme } from "@/utils/styling/colours";
import * as Styled from "./AchievementDashboard.styled";
const AchievementDashboard: React.FC = () => {
  const [filter, setFilter] = useState<"all" | "completed" | "in-progress">("all");
  const [tasks, setTasks] = useState<TaskDTO[]>([]);
  const [dailyTasks, setDailyTasks] = useState<TaskDTO[]>([]);

  // Fetch tasks when the component mounts
  useEffect(() => {
    (async () => {
      try {
        const {
          tasks,
          dailyTasks
        } = await fetchAllTasks();

        // Sort tasks based on the given criteria
        const sortTasks = (tasks: TaskDTO[]) => {
          return tasks.sort((a, b) => {
            // 1. Rewards that can be claimed
            if (!a.completed && a.currentProgress >= a.goal) return -1;
            if (!b.completed && b.currentProgress >= b.goal) return 1;

            // 2. Not completed with the smallest goal first
            if (!a.completed && !b.completed) return a.goal - b.goal;

            // 3. Completed
            if (a.completed && !b.completed) return 1;
            if (!a.completed && b.completed) return -1;
            return 0;
          });
        };
        if (tasks) {
          setTasks(sortTasks(tasks));
        }
        if (dailyTasks) {
          setDailyTasks(sortTasks(dailyTasks));
        }
        if (tasks) {
          setTasks(tasks);
        }
        if (dailyTasks) {
          setDailyTasks(dailyTasks);
        }
      } catch (e: any) {
        console.log(e);
      }
    })();
  }, []);

  // Function to filter tasks based on filter state and task type
  const filteredTasks = (taskType: "DAILY" | "REGULAR") => taskType === "DAILY" ? dailyTasks.filter(task => {
    if (filter === "all") return task.taskType === taskType;
    if (filter === "completed") return task.completed && task.taskType === taskType;
    if (filter === "in-progress") return !task.completed && task.taskType === taskType;
    return task.taskType === taskType;
  }) : tasks.filter(task => {
    if (filter === "all") return task.taskType === taskType;
    if (filter === "completed") return task.completed && task.taskType === taskType;
    if (filter === "in-progress") return !task.completed && task.taskType === taskType;
    return task.taskType === taskType;
  });
  return <Styled.Container data-sentry-element="unknown" data-sentry-component="AchievementDashboard" data-sentry-source-file="index.tsx">
            <Styled.Title data-sentry-element="unknown" data-sentry-source-file="index.tsx">Achievement Dashboard</Styled.Title>
            <div style={{
      marginBottom: "1rem",
      display: "flex",
      gap: "0.5rem",
      flexWrap: "wrap"
    }}>
                <Styled.FilterButton active={filter === "all"} onClick={() => setFilter("all")} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    All Tasks
                </Styled.FilterButton>
                <Styled.FilterButton active={filter === "in-progress"} onClick={() => setFilter("in-progress")} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    In Progress
                </Styled.FilterButton>
                <Styled.FilterButton active={filter === "completed"} onClick={() => setFilter("completed")} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    Completed
                </Styled.FilterButton>
            </div>
            <Tabs defaultValue="DAILY" data-sentry-element="Tabs" data-sentry-source-file="index.tsx">
                <Styled.StyledTabsList data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    <Styled.StyledTabsTrigger value="DAILY" activeColor={colourScheme.bgAccent1} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        Daily Tasks
                    </Styled.StyledTabsTrigger>
                    <Styled.StyledTabsTrigger value="REGULAR" activeColor={colourScheme.bgAccent2} data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        Achievements
                    </Styled.StyledTabsTrigger>
                </Styled.StyledTabsList>
                <TabsContent value="DAILY" data-sentry-element="TabsContent" data-sentry-source-file="index.tsx">
                    <Styled.TaskGrid data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        {filteredTasks("DAILY").map(task => <TaskCard key={task.id} task={task} />)}
                    </Styled.TaskGrid>
                </TabsContent>
                <TabsContent value="REGULAR" data-sentry-element="TabsContent" data-sentry-source-file="index.tsx">
                    <Styled.TaskGrid data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                        {filteredTasks("REGULAR").map(task => <TaskCard key={task.id} task={task} />)}
                    </Styled.TaskGrid>
                </TabsContent>
            </Tabs>
        </Styled.Container>;
};
export default AchievementDashboard;